document.addEventListener("DOMContentLoaded", () => {
  const localized_url = window.localizedUrlRoot || '/';


  if (window.customerData && Array.isArray(window.customerData.customerTag)) {
    const tags = window.customerData.customerTag;

    const isDisabledPage = window.location.pathname.includes("/pages/disable-user");

    if (tags.includes("disabled") || tags.includes("deleted")) {
      if (!isDisabledPage) {
        window.location.href = `${localized_url}/pages/disable-user`;
      }

      if (isDisabledPage) {

        // removing tokens from local storage
          localStorage.removeItem("gbRefreshTokenExpiresIn");
          localStorage.removeItem("gbToken");
          localStorage.removeItem("gbTokenExpiresIn");
          localStorage.removeItem("gbRefreshToken");

          //logging out customer 
         const allCleared =
                  !localStorage.getItem("gbRefreshTokenExpiresIn") &&
                  !localStorage.getItem("gbToken") &&
                  !localStorage.getItem("gbTokenExpiresIn") &&
                  !localStorage.getItem("gbRefreshToken");
          
          console.log("all local storage clear response",allCleared);
          if (allCleared) {
            // Logging out customer after 3 seconds
            setTimeout(() => {
              window.location.href = `${localized_url}/account/logout`;
            }, 3000);
          }
      }
    }
  }
});
